export default __webpack_public_path__ + "static/media/Quatro-Slab-Regular.004e0572.ttf";